import { EditorState, Modifier } from 'draft-js';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

import './toolbar-link-button.styles.scss';

export const ToolbarLinkButton = (props) => {
	const { editorState, onChange, className } = props;

	const execute = () => {
    const linkText = 'Click here to begin your Online Family History Questionnaire';
    const linkUrl = '{LINK}';
    
    // Get the current selection
    const selection = editorState.getSelection();
    const currentContent = editorState.getCurrentContent();
    
    // If there's selected text, use it; otherwise insert our default text
    let contentState;
    let newSelection;
    
    if (selection.isCollapsed()) {
      // No text selected, insert our default text
      contentState = Modifier.replaceText(
        currentContent,
        selection,
        linkText
      );
      
      // Update selection to cover the inserted text
      newSelection = selection.merge({
        anchorOffset: selection.getStartOffset(),
        focusOffset: selection.getStartOffset() + linkText.length,
      });
    } else {
      // Text is selected, use it
      contentState = currentContent;
      newSelection = selection;
    }
    
    // Create the link entity
    contentState = contentState.createEntity('LINK', 'MUTABLE', {
      url: linkUrl,
      title: linkText
    });
    
    const entityKey = contentState.getLastCreatedEntityKey();
    
    // Apply the entity to the text
    contentState = Modifier.applyEntity(
      contentState,
      newSelection,
      entityKey
    );
    
    // Create new editor state
    const newEditorState = EditorState.push(
      editorState,
      contentState,
      'apply-entity'
    );
    
    // Update the selection to collapse at the end
    const finalEditorState = EditorState.forceSelection(
      newEditorState,
      newSelection.merge({
        anchorOffset: newSelection.getFocusOffset(),
        focusOffset: newSelection.getFocusOffset(),
      })
    );
    
    onChange(finalEditorState);
	};

	return (
		<span 
      className={cx('rdw-option-wrapper TextEditorToolbarLinkButton', className)} 
      title={I18n.t("Insert hyperlink with {LINK} placeholder")}
      onClick={execute}
    >
      {'{L}'}
    </span>
	);
};